import { render, staticRenderFns } from "./ParcelAdditionalService.vue?vue&type=template&id=88eae6fa&"
import script from "./ParcelAdditionalService.vue?vue&type=script&lang=js&"
export * from "./ParcelAdditionalService.vue?vue&type=script&lang=js&"
import style0 from "./ParcelAdditionalService.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports